import { useEffect } from 'react';
import isGotInitDataAtom from '~/recoil/atom/isGotInitData';
import { useRecoilValue } from 'recoil';

import { Navigate, Outlet, useParams, useLocation } from 'react-router-dom';

import LoadingModal from '~/components/LoadingModal';
import { storeLocaleSelector } from '~/recoil/selectors/storeLocale';
import { isServiceShutdown, SHUTDOWN_ALLOW_PATHS } from '~/config/serviceShutdown';

// NOTE: add store id and domain map here
const storeDomainMap: Record<string, string> = {
  fpBROOlpjZyfF1F9TSOd: 'www.theslice.shop',
};

export default function RequireGlobalMiddleware() {
  const store = useRecoilValue(storeLocaleSelector);
  const isGotInitData = useRecoilValue(isGotInitDataAtom);

  const { storeId = '' } = useParams();
  const { pathname } = useLocation();

  useEffect(() => {
    if (storeDomainMap[storeId] && window.location.host !== storeDomainMap[storeId]) {
      window.location.replace(`https://${storeDomainMap[storeId]}${window.location.pathname}`);
    }
  }, [storeId]);

  if (!isGotInitData.store) {
    return <LoadingModal isVisible={true} />;
  }

  if (isGotInitData.store && !store) {
    return <Navigate to="/404" />;
  }

  // 系統停止營運後，僅保留店家資訊與訂單查詢，其餘一律導回店家主頁
  if (isServiceShutdown()) {
    const subPath = pathname.replace(new RegExp(`^/${storeId}/?`), '').replace(/\/$/, '');

    if (!SHUTDOWN_ALLOW_PATHS.includes(subPath)) {
      return <Navigate to={`/${storeId}`} replace />;
    }
  }

  return <Outlet />;
}
